import React from 'react';
import { Outlet } from 'react-router-dom';

type Props = {};

const SmartHubPageLayout = (props: Props) => {
    return (
        <><Outlet /></>
    );
};

export default SmartHubPageLayout;